import React from "react";
import { Box, Select, MenuItem, Typography, Pagination, PaginationItem } from "@mui/material";

function CustomTablePagination({ count, page, rowsPerPage, onPageChange, onRowsPerPageChange }) {
  const totalPages = Math.ceil(count / rowsPerPage);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py={1}
      px={2}
      borderTop="1px solid var(--gray-25)"
    >
      {/* Left Side */}
      <Box display="flex" alignItems="center" gap={1}>
        <Select
          value={rowsPerPage}
          onChange={onRowsPerPageChange}
          size="small"
          sx={{ minWidth: 10, height: 32 }}
        >
          {[10, 20, 35, 50].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
        <Typography variant="body2">per page</Typography>
      </Box>

      {/* Right Side - Custom Pagination */}
      <Pagination
      variant="bodySmall"
        count={totalPages}
        page={page + 1}
        onChange={(_, value) => onPageChange(null, value - 1)}
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            components={{
              previous: () => <Typography variant="bodySmall">{'< Previous'}</Typography>,
              next: () => <Typography variant="bodySmall">{'Next >'}</Typography>,
            }}
            sx={{
                backgroundColor: 'transparent !important',
                '&.Mui-selected': {
                  backgroundColor: 'transparent ',
                  fontWeight: 'bold',
                  color: 'var(--brand-600)',
                },
                '&:hover': {
                    backgroundColor: 'transparent',
                  },
            }}
          />
        )}
        size="small"
      />
    </Box>
  );
}

export default CustomTablePagination;
